import React from 'react';

export default function GlobalDocumentsGridLoading() {
  return [...Array(16)].map(() => (
    <div className="col-span-12 h-[64px] rounded-[8px] bg-muted lg:col-span-6"></div>
  ));
}
